import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { firestore, withActor } from '../../backend'
import { collection, doc, updateDoc, query, where, setDoc, getDocs } from 'firebase/firestore'

export const saveProduct = createAsyncThunk('products/saveProduct', async ({ id, data }) => {
	if (id) {
		return updateDoc(doc(firestore, 'products', id), withActor(data))
	} else {
		const productId = doc(collection(firestore, 'products')).id
		return setDoc(doc(firestore, 'products', productId), withActor(data, { create: true }), { merge: true })
	}
})

export const fetchProducts = createAsyncThunk('products/fetchProducts', async (venueId, { dispatch }) => {
	try {
		const querySnapshot = await getDocs(query(collection(firestore, 'products'), where('etablissement', '==', venueId)))
		const products = querySnapshot.docs
			.filter(doc => !doc.data().isDeleted || !doc.data().hidden)
			.map(doc => ({ ...doc.data(), id: doc.id }))
			.sort((a, b) => {
				if (String(a.title).toLowerCase() > String(b.title).toLowerCase()) return 1
				if (String(a.title).toLowerCase() < String(b.title).toLowerCase()) return -1
				return 0
			})
		dispatch(setProducts(products))
	} catch (error) {
		console.log(error)
	}
})

export const productsSlice = createSlice({
	name: 'products',
	initialState: {
		value: [],
		status: 'idle',
		error: null,
	},
	reducers: {
		setProducts: (state, action) => {
			state.value = action.payload
		},
		setProductStatus: (state, action) => {
			state.status = action.payload
		},
	},
	extraReducers: {
		[saveProduct.pending]: (state, action) => {
			state.status = 'loading'
		},
		[saveProduct.fulfilled]: (state, action) => {
			state.status = 'succeeded'
		},
		[saveProduct.rejected]: (state, action) => {
			state.status = 'failed'
			state.error = action.error.message
		},
	},
})

// export const fetchProducts = venueId => dispatch => {
// 	return onSnapshot(
// 		query(collection(firestore, 'products'), where('etablissement', '==', venueId)),
// 		querySnapshot => {
// 			const products = querySnapshot.docs
// 				.filter(doc => !doc.data().isDeleted || !doc.data().hidden)
// 				.map(doc => ({ ...doc.data(), id: doc.id }))
// 				.sort((a, b) => {
// 					if (String(a.title).toLowerCase() > String(b.title).toLowerCase()) return 1
// 					if (String(a.title).toLowerCase() < String(b.title).toLowerCase()) return -1
// 					return 0
// 				})
// 			dispatch(setIsProductsLoaded(true))
// 			dispatch(setProducts(products))
// 		},
// 		error => {
// 			console.log(error)
// 		}
// 	)
// }

export const getProducts = state => state.products.value
export const getProductStatus = state => state.products.status

export const { setProducts, setProductStatus } = productsSlice.actions

export default productsSlice.reducer
